<template>
  <div>
    <div v-html="contentElement.label_title"></div>
    <help-tooltip v-if="contentElement.help_text" :text="contentElement.help_text"></help-tooltip>
  </div>

</template>
<script>
  import Vue from "vue";
  import HelpText from "~/components/helpText.vue"
  import ContentElementComponent from "./content-element-component.vue";

  export default Vue.extend({
    extends: ContentElementComponent,
    components: {HelpText},
  });
</script>